import { Dispatch } from 'redux';
import PageGroupController from '../controllers/PageGroupController';
import commonHandler from '../errorHandlers/common-handler';
import { pageGroupErrorHandler } from '../errorHandlers/page-group-hanlder';
import PageGroupModel from '../model/PageGroupModel';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';
import pageCRUDActions from './PageCRUDActions';

class PageGroupCRUDActions extends CrudActionContainer {
  constructor() {
    super('PAGE_GROUP');
  }

  create(entity: Omit<PageGroupModel, 'id'>) {
    return (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.createAction));

      return PageGroupController.post(entity)
        .then(response => {
          dispatch(this.retrieveAll(entity.botId));

          return response;
        })
        .catch(commonHandler(dispatch));
    };
  }

  retrieveAll(chatbotId: number) {
    return (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));

      return PageGroupController.getAll(chatbotId)
        .then(response => {
          dispatch(
            this.retrievedAll(
              response.sort((a, b) => a.sortOrder - b.sortOrder),
            ),
          );

          return response;
        })
        .catch(commonHandler(dispatch));
    };
  }

  update(entity: Partial<PageGroupModel>) {
    return (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.updateAction));

      return PageGroupController.put(entity)
        .then(response => {
          dispatch(this.updateLocal(entity));

          return response;
        })
        .catch(commonHandler(dispatch));
    };
  }

  batchUpdate(entities: Partial<PageGroupModel>[], chatbotId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.localBatchUpdate(entities));
        const response = await PageGroupController.patch(entities);
        dispatch(this.retrieveAll(chatbotId));
        return response;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  }

  delete(chatbotId: number, pageGroupId: number) {
    return (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.deleteAction));

      return PageGroupController.delete(pageGroupId)
        .then(response => {
          dispatch(pageCRUDActions.retriveDropdownPages(chatbotId));

          return response;
        })
        .catch(pageGroupErrorHandler(dispatch));
    };
  }
}

const pageGroupCRUDActions = new PageGroupCRUDActions();

export default pageGroupCRUDActions;

export const usePageGroupCRUDActions = getActionHookBuilder(
  pageGroupCRUDActions,
  ['batchUpdate', 'create', 'retrieveAll', 'update', 'updateLocal', 'delete'],
);
